window.onload = function () {
  var imgUrl =
    "https://cdn.shopify.com/s/files/1/0878/7817/3007/files/cookie-logo.svg?v=1728978523";
  var imgElement = $("<img>")
    .attr("src", imgUrl)
    .attr("alt", "Cookies Banner Image");
  $(".shopify-pc__banner__body").prepend(imgElement);
  $(".shopify-pc__banner__dialog").css("display", "block");





  
  // setTimeout(function() { 
  //       const optionData = document.querySelector('.jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown');
  //     const reviewContainer = document.querySelector('.jdgm-rev-widg__body');


  // if (optionData && reviewContainer) {

  //     console.log('Reviews..............................');
    
  //   // Save the current scroll position
  //   const originalScrollPosition = window.scrollY;

  //   // Temporarily disable automatic scrolling
  //   optionData.blur();

  //   // Find the option by value
  //   const optionToSelect = optionData.querySelector('option[value="highest-rating"]');

  //   if (optionToSelect) {
  //     optionData.value = optionToSelect.value;

  //     // Trigger the change event to simulate a user action
  //     const event = new Event('change', { bubbles: true });
  //     optionData.dispatchEvent(event);

  //     // Monitor review loading using MutationObserver
  //     const observer = new MutationObserver(() => {
  //       if (reviewContainer.querySelector('.jdgm-rev')) {
  //         // Reviews are loaded, restore scroll position
  //         window.scrollTo(0, originalScrollPosition);

  //         // Disconnect the observer
  //         observer.disconnect();
  //       }
  //     });

  //     // Start observing changes in the review container
  //     observer.observe(reviewContainer, { childList: true, subtree: true });

  //     // Fallback to restore scroll after a timeout
  //     setTimeout(() => {
  //       window.scrollTo(0, originalScrollPosition);
  //       observer.disconnect();
  //     }, 1000); // Adjust timeout as needed
  //   }
  //   // $('.oproduct').css('opacity','1')
  //   // Optional: Log for debugging
  //   console.log('Selected option:', optionData.value);
  // }

  //   }, 2000);

  
};
const sections = document.querySelectorAll('.jdgm-rev-widg');

// Create a new IntersectionObserver instance
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    // Check if the section is in view
    if (entry.isIntersecting) {
      console.log('Section in view:', entry.target.className);  // Debugging the class name

      // Get the dropdown options
      const optionsData = document.querySelectorAll('.jdgm-sort-dropdown');
      console.log('Dropdown options found:', optionsData);

      // Look for the option with value 'highest-rating'
      optionsData.forEach(dropdown => {
        const optionToSelect = dropdown.querySelector('option[value="highest-rating"]');
        console.log('Option to select:', optionToSelect);

        if (optionToSelect) {
          // Update the dropdown value
          dropdown.value = optionToSelect.value;

          // Trigger the change event to simulate user selection
          const event = new Event('change', { bubbles: true });
          dropdown.dispatchEvent(event);

          console.log('Dropdown updated with value:', optionToSelect.value);
          // $('#shopify-section-template--24152925733210__173097485550b61506').css('height','auto');
           // $('.#shopify-section-template--24152925733210__173097485550b61506').css('opacity','1');

          
        } else {
          console.log('No option found for "highest-rating"');
        }
      });

      // Monitor review loading using MutationObserver
      const reviewContainer = entry.target.querySelector('.jdgm-reviews-container');
      console.log('Review container:', reviewContainer);

      const mutationObserver = new MutationObserver(() => {
        const reviewsLoaded = reviewContainer.querySelectorAll('.jdgm-rev').length > 0;
        console.log('Reviews loaded:', reviewsLoaded);

        if (reviewsLoaded) {
          console.log('Reviews are loaded.');
          mutationObserver.disconnect(); // Disconnect observer after reviews are loaded
        }
      });

      // Start observing changes in the review container
      if (reviewContainer) {
        mutationObserver.observe(reviewContainer, { childList: true, subtree: true });
      } else {
        console.log('Review container not found.');
      }

      // Stop observing the current section to avoid repeated triggers
      observer.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.5 // Trigger when 50% of the section is visible
});

// Observe each section
sections.forEach(section => {
  observer.observe(section);
});

// document.addEventListener('DOMContentLoaded', function () {


// }



